import { JOB_FORMATS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const JobFormatService = {
  getAll: (params: any) => requests.get(`${JOB_FORMATS_URL}`, params),
  create: (params: any) => requests.post(`${JOB_FORMATS_URL}`, params),
  getSingle: (id: number) => requests.get(`${JOB_FORMATS_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${JOB_FORMATS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_FORMATS_URL}/${id}`),
};